export default __webpack_public_path__ + "static/media/layout-select-img.967e49d9.png";